/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, FormControlLabel, Grid, TextField } from '@material-ui/core';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  contractMfgTableColDefs,
  contractDrugFamilyTableColDefs,
  contractMarketBasketTableColDefs,
  contractTableColDefs,
  drugFamilyContractTableHead,
  marketBasketContractTableHead,
} from './TableHeads';
import {
  setErrorMessage,
  getRebateProgrameList,
  getPlanTypeValues,
  getcontractmfggrid,
  getcontractdruggrids,
  getcontractmarketbasketgrid,
  getcontractgrid,
  getcontractseqnummfgtype,
  getcontractdetailreport,
  getContractValidationDetails,
  getContractMarketBasketSeqnum,
  getContractDrugDetails,
  setOpenValue,
} from '../Store/actions';
import Spinner from '../../../../SharedModules/Spinner/Spinner';

import {
  autoFormateDate,
  convertToFourDigitYear,
  monthMapping,
  tabHighLigther,
  validateDate,
  validateQuarter,
  checkActionAccessByRole,
} from '../../../../SharedModules/utilities/utilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import { viewPortHeight_350 } from '../../../../SharedModules/CommonConstants/commonConstants';
import AdditionalTableDialog from './AdditionalTableDialog';
import {
  REBATE_PROGRAM_REQUIRED,
  SELECT_ONE_OPTION,
} from '../../../../SharedModules/Errors/constantMessageData';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const RequestContract = (props) => {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    selectedPlanType,
    rebateProgram: rebateProgramValue,
    rebateProgramList: rebateProgramListData,
    validateValue,
    viewValue,
    qtrValue,
    dateValue,
    contractMfgGrid,
    contractDrugFamilyGrid,
    contractGrid,
    contractMarketBasketGrid,
    selectTypeValue,
    openValue,
    drugFamilyContractGrid,
  } = useSelector((state) => state?.sharedState?.ContractReportReducer);
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [hasAccess, setHasAccess] = useState(
    checkActionAccessByRole(process.env.REACT_APP_REPORT_ROLE, kcRoles)
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [errorList, setErrorList] = React.useState(errors);
  const [radioList, setRadioList] = React.useState([]);
  const [selectList, setSelectList] = React.useState([]);
  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [validate, setValidate] = React.useState(validateValue);
  const [view, setView] = React.useState(viewValue);
  const [qtr, setQtr] = React.useState(qtrValue);
  const [date, setDate] = React.useState(dateValue);
  const [selectType, setSelectType] = React.useState(selectTypeValue);
  const [open, setOpen] = React.useState(false);
  const [tableVisisble, setTableVisible] = React.useState(true);
  React.useEffect(() => {
    setOpen(openValue);
  }, [openValue]);
  const [selectTypeList, setSelectTypeList] = React.useState([
    {
      name: 'Manufacturer/Rebate Program',
      value: 'Manufacturer/Rebate Program',
    },
    {
      name: 'Drug Family',
      value: 'Drug Family',
    },
    {
      name: 'Market Basket',
      value: 'Market Basket',
    },
    {
      name: 'Contract',
      value: 'Contract',
    },
  ]);
  const [selectedRow, setSelectedRow] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [selectedContract, setSelectedContract] = React.useState([]);
  // Function to toggle fullscreen view of table
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // set selected row on selection changes of grid
  const onSelectionChanged = (e) => {
    const selectedRows = e.api.getSelectedRows() || [];
    setSelectedRow(selectedRows);
  };

  // set selected row on selection changes of grid of additional Table for DRUG family and Market Basket
  const onContractSelectionChanged = (e) => {
    const selectedContract = e.api.getSelectedRows() || [];
    setSelectedContract(selectedContract);
  };
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  // Sets data for rebate program dropdown
  const rebatepgmDropdown = async (planType) => {
    dispatch(setErrorMessage([]));
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
    }
  }, [planType]);

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  // API Cal to get Contract MFG grid data
  const callMfgApi = (qtr) => {
    dispatch(
      getcontractmfggrid({
        rebateProgramCd: rebateProgram,
        qtr,
      })
    );
  };

  // API call to Contract druggrids Api
  const callContractdruggridsApi = (date) => {
    const d = date.split('/');
    dispatch(
      getcontractdruggrids({
        date: `${d[1]}-${monthMapping[d[0]]}-${d[2]}`,
      })
    );
  };

  // API callto  Contract Grid API
  const callContractGridAPI = (date) => {
    const d = date.split('/');
    dispatch(
      getcontractgrid({
        date: `${d[1]}-${monthMapping[d[0]]}-${d[2]}`,
      })
    );
  };

  // API callto  Contract Grid API
  const callContractMarketBasketGridAPI = (date) => {
    const d = date.split('/');
    dispatch(
      getcontractmarketbasketgrid({
        date: `${d[1]}-${monthMapping[d[0]]}-${d[2]}`,
      })
    );
  };

  // This function cal data grid api for select Type on On Blur of time
  const apiCallOnTimeChange = (type, input) => {
    if (type === 'date') {
      switch (selectType) {
        case 'Drug Family':
          callContractdruggridsApi(input);
          break;
        case 'Market Basket':
          callContractMarketBasketGridAPI(input);
          break;
        case 'Contract':
          callContractGridAPI(input);
          break;
        default:
          break;
      }
    }
    if (type === 'qtr') {
      callMfgApi(input);
    }
  };

  React.useEffect(() => {
    callMfgApi(qtr);
  }, [rebateProgram]);

  // API call on select type get changed
  React.useEffect(() => {
    apiCallOnTimeChange('date', date);
  }, [selectType]);

  // function to conver 2 digit year to 4 digit ear
  const convertTo4DigitQtr = (value) => {
    const tempValue = value.split('Q');

    tempValue.splice(1, 1, convertToFourDigitYear(tempValue[1]));
    return tempValue.join('Q');
  };

  // Handle onblur events for date and quarter
  const handleOnBlur = (type, value) => {
    dispatch(setErrorMessage([]));
    let localErrors = errorList;
    if (type === 'qtr') {
      localErrors = localErrors.filter((error) => error.field != 'qtr');
      const qtrErr = validateQuarter(value, 'qtr', true);
      if (qtrErr.length === 0) {
        const qtr = value.length == 4 ? convertTo4DigitQtr(value) : value;
        setQtr(qtr);

        apiCallOnTimeChange(type, qtr);
        // callMfgApi(qtr);
      } else {
        localErrors = [...localErrors, ...qtrErr];
      }
    }
    if (type === 'date') {
      localErrors = localErrors.filter((error) => error.field != 'date');
      if (value === '')
        localErrors = [
          ...localErrors,
          { field: type, message: 'As of Date is required.' },
        ];
      else {
        const dateErr = validateDate(value, type);
        if (dateErr.length === 0) {
          apiCallOnTimeChange(type, value);
        } else {
          localErrors = [...localErrors, ...dateErr];
        }
      }
    }
    setErrorList(localErrors);
  };
  // API to get the plan type list
  React.useEffect(() => {
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);
  
  //remove no data error msg
  React.useEffect(() => {
    dispatch(setErrorMessage([]));
  }, [planType, planTypeList, selectType, rebateProgram, selectedContract]);
  

  // Generate report for contract and validation if there is no error on click on search buttom
  const handleSearchClick = () => {
    dispatch(setErrorMessage([]));
    let localErrors = [];
    if (!view && !validate) {
      localErrors.push({
        field: 'selectOneOption',
        message: SELECT_ONE_OPTION,
      });
    }
    if (selectType === 'Manufacturer/Rebate Program')
      if (rebateProgram === '-1') {
        localErrors.push({
          field: 'rebateProgram',
          message: REBATE_PROGRAM_REQUIRED,
        });
      }
    if (selectType === 'Manufacturer/Rebate Program') {
      const qtrErr = validateQuarter(qtr, 'qtr', true);
      localErrors = [...localErrors, ...qtrErr];
    } else {
      const dateErr = validateDate(date, 'date');
      localErrors = [...localErrors, ...dateErr];
    }

    setErrorList(localErrors);
    if (localErrors.length === 0) {
      if (selectType === 'Manufacturer/Rebate Program') {
        const selectedManufacturer =
          selectedRow.length > 0 ? selectedRow[0] : contractMfgGrid[0];
        dispatch(
          getcontractseqnummfgtype(
            {
              rebateProgramCd: rebateProgram,
              qtr: qtr,
              mfgid: selectedManufacturer?.mfgId,
            },
            userDefaults,
            view,
            validate
          )
        );
      }

      if (selectType === 'Contract') {
        const selectedContract =
          selectedRow.length > 0 ? selectedRow[0] : contractGrid[0];

        if (view) {
          dispatch(
            getcontractdetailreport(
              {
                contractId: selectedContract.contractSeqNum,
              },
              userDefaults,
              logInUser
            )
          );
        }
        if (validate) {
          dispatch(
            getContractValidationDetails(
              {
                contractid: selectedContract.contractSeqNum,
              },
              userDefaults,
              logInUser
            )
          );
        }
      }
      if (selectType === 'Drug Family') {
        const selectedDrugFamily =
          selectedRow.length > 0 ? selectedRow[0] : contractDrugFamilyGrid[0];
        const d = date.split('/');
        dispatch(
          getContractDrugDetails(
            {
              familyId: selectedDrugFamily?.familySeqNum,
              date: `${d[1]}-${monthMapping[d[0]]}-${d[2]}`,
            },
            userDefaults,
            view,
            validate
          )
        );
      }
      if (selectType === 'Market Basket') {
        const selectedMarketBasket =
          selectedRow.length > 0 ? selectedRow[0] : contractMarketBasketGrid[0];
        dispatch(
          getContractMarketBasketSeqnum(
            {
              date: date.split('/').join('-'),
              marketBasketSeqNum: selectedMarketBasket?.marketBasketSeqNum,
            },
            userDefaults,
            view,
            validate
          )
        );
      }
    }
  };

  // select cotract id for drug family and Market basket and generate report
  const onSelectContractFromAdditionalTable = () => {
    dispatch(setErrorMessage([]));
    const selectedDrugContract =
      selectedContract.length > 0
        ? selectedContract[0]
        : drugFamilyContractGrid[0];

    if (view) {
      dispatch(
        getcontractdetailreport(
          {
            contractId: selectedDrugContract?.contractSeqNum,
          },
          userDefaults,
          logInUser
        )
      );
    }
    if (validate) {
      dispatch(
        getContractValidationDetails(
          {
            contractid: selectedDrugContract?.contractSeqNum,
          },
          userDefaults,
          logInUser
        )
      );
    }
  };

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator parent1="Detail Reports" parent2="Contract Report" />
      <DisplayErrorMessages
        errorMessages={[
          ...(Array.isArray(errorList)
            ? errorList.map((l) => l.message)
            : []),
          ...(Array.isArray(errors)
            ? errors.map((l) => l.message)
            : []),
        ]}
      />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row" style={{ marginTop: 15 }}>
              <div className="col-8 frr-one-col-radio">
                <RadioGroupComponent
                  data-testid="contract-select-type"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Select Type"
                  required
                  optionList={selectTypeList}
                  defaultValue={selectType}
                  filterAction={(value) => {
                    setSelectedRow([]);
                    setSelectType(value);
                    if (
                      value === 'Manufacturer/Rebate Program' &&
                      planType === 'FD'
                    ) {
                      setQtr(qtrValue);
                      setValidate(false);
                    } else {
                      setDate(dateValue);
                    }
                    const errors = errorList.filter(
                      (error) =>
                        !['rebateProgram', 'date', 'qtr'].includes(error.field)
                    );
                    setErrorList([...errors]);
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-4">
                <>
                  <Fieldset
                    label="Select One Option"
                    isError={
                      errorList.filter(
                        (error) => error.field === 'balanceStatus'
                      ).length
                    }
                    required
                  >
                    <div className="filter-checkbox">
                      <FormControlLabel
                        control={
                          <>
                            <div style={{ width: 45, marginLeft: 5 }}>
                              View:{' '}
                            </div>
                            <Checkbox
                              data-testid="contract-checkbox-view"
                              color="primary"
                              onChange={(e) => {
                                setView(!view);
                                const errors = errorList.filter(
                                  (error) => error.field !== 'selectOneOption'
                                );
                                setErrorList([...errors]);
                              }}
                              checked={view}
                            />
                          </>
                        }
                      />
                    </div>
                    <div className="filter-checkbox">
                      <FormControlLabel
                        control={
                          <>
                            <div style={{ width: 67, marginLeft: 5 }}>
                              Validate:{' '}
                            </div>
                            <Checkbox
                              color="primary"
                              data-testid="contract-checkbox-validate"
                                disabled={
                                (planType === 'FD' &&
                                  selectType ===
                                    'Manufacturer/Rebate Program') ||selectType==='Contract'||
                                !hasAccess
                              }
                              onChange={(e) => {
                                setValidate(!validate);
                                const errors = errorList.filter(
                                  (error) => error.field !== 'selectOneOption'
                                );
                                setErrorList([...errors]);
                              }}
                              checked={validate}
                            />
                          </>
                        }
                      />
                    </div>
                  </Fieldset>
                </>
              </div>
            </div>
            {selectType === 'Manufacturer/Rebate Program' && (
              <div className="row" style={{ marginTop: 15 }}>
                <div className="col-8 frr-one-col-radio">
                  <RadioGroupComponent
                    data-testid="contract-plan-type"
                    id="filter-plan-by-radio-btn-action"
                    labelName="Plan Type"
                    required
                    optionList={radioList || []}
                    defaultValue={planType}
                    filterAction={(value) => {
                      setPlanType(value);
                      setRebateProgram('-1');
                      const errors = errorList.filter(
                        (error) => error.field !== 'rebateProgram'
                      );
                      setErrorList([...errors]);
                      if (
                        selectType === 'Manufacturer/Rebate Program' &&
                        value === 'FD'
                      ) {
                        setValidate(false);
                      }
                    }}
                    className="log-batch-filter-radio frr-checkInvoiceRadio"
                  />
                </div>
                <div className="col-4">
                  <>
                    <Fieldset label="Rebate Program" required>
                      <div style={{ marginTop: 5 }}>
                        <SelectBoxComponent
                          data-testid="contract-rebate-program"
                          id="filter-plan-by-radio-btn-action"
                          label="filter-plan-by-radio-btn-action"
                          labelName="Rebate Program"
                          required
                          select
                          selectOne
                          optionList={selectList || []}
                          defaultValue={rebateProgram}
                          filterAction={(value) => {
                            setRebateProgram(value);
                            const errors = errorList.filter(
                              (error) => error.field !== 'rebateProgram'
                            );
                            setErrorList([...errors]);
                            // setTableVisible(false);
                            // setTimeout(() => {
                            //   setTableVisible(true);
                            // }, 100);
                            setTableVisible(true);
                          }}
                          isError={
                            errorList.find(
                              (error) => error.field === 'rebateProgram'
                            )?.message
                          }
                        />
                      </div>
                    </Fieldset>
                  </>
                </div>
              </div>
            )}

            <div className="row" style={{ marginTop: 15 }}>
              {selectType === 'Manufacturer/Rebate Program' && (
                <div className="col-3">
                  <div className="form-wrapper p-0 mt-n3">
                    <div className="mui-custom-form input-md field-xl">
                      <TextField
                        label="Quarter"
                        id="Quarter"
                        placeholder=""
                        data-testid="contract-qtr"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 6 }}
                        required
                        name="From"
                        value={qtr}
                        error={
                          errorList.filter((error) => error.field === 'qtr')
                            ?.length > 0
                            ? 'mandate-fields'
                            : ''
                        }
                        helperText={
                          errorList.find((error) => error.field === 'qtr')
                            ?.message
                        }
                        className="mandate-fields"
                        onBlur={(e) => handleOnBlur('qtr', e?.target?.value)}
                        onChange={(e) => {
                          const { value } = e.target;
                          const localErrors = errorList.filter(
                            (error) => error.field != 'qtr'
                          );
                          setErrorList(localErrors);
                          setQtr(value.toUpperCase());
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
              {selectType !== 'Manufacturer/Rebate Program' && (
                <div className="col-3">
                  <div className="form-wrapper p-0 mt-n3">
                    <div className="mui-custom-form input-md field-xl">
                      <TextField
                        label="As of Date"
                        id="As of Date"
                        placeholder="MM/DD/YYYY"
                        data-testid="contract-date"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        required
                        name="date"
                        value={date}
                        error={
                          errorList.filter((error) => error.field === 'date')
                            ?.length > 0
                            ? 'mandate-fields'
                            : ''
                        }
                        helperText={
                          errorList.find((error) => error.field === 'date')
                            ?.message
                        }
                        className="mandate-fields"
                        onBlur={(e) => {
                          let value = e?.target?.value;
                          value = autoFormateDate(value);
                          setDate(value);
                          handleOnBlur('date', value);
                        }}
                        onChange={(e) => {
                          const { value } = e.target;
                          const localErrors = errorList.filter(
                            (error) => error.field != 'date'
                          );
                          setErrorList(localErrors);
                          setDate(value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="row" style={{ marginTop: 30 }}>
              <div className="btn-wrapper col-12">
                <Button
                  data-testid="contract-handleSearch"
                  onClick={handleSearchClick}
                  className="btn btn-success btn-search float-right"
                >
                  <SVGComponent iconName="Icon-search" /> Search
                </Button>
              </div>
            </div>
          </>
        )}
        <div className="row" style={{ marginTop: 15 }}>
          <div className="unallocated" style={{ width: '100vw' }}>
            {selectType === 'Manufacturer/Rebate Program' && tableVisisble && (
              <TableGridWithFeatures
                gridHeight={fullScreenView ? 600 : viewPortHeight_350}
                columnDefs={contractMfgTableColDefs}
                onSelectionChanged={onSelectionChanged}
                rowData={Array.isArray(contractMfgGrid) ? contractMfgGrid : []}
                data-testid="onEditingStopped"
                enterMovesDown
                showResetFilter={false}
                selectRowIndex={0}
                defaultCol={{
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                }}
                hideTotalCount={false}
                exportFile
                fileName="Contract"
                reportName="Contract"
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={changeFullScreenView}
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;

                    if (name && name.length > 20) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
                //   info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
                //   pinnedBottomRowData={pinnedBottomRowData}
              />
            )}
            {selectType === 'Drug Family' && (
              <TableGridWithFeatures
                gridHeight={fullScreenView ? 600 : viewPortHeight_350}
                columnDefs={contractDrugFamilyTableColDefs}
                onSelectionChanged={onSelectionChanged}
                rowData={Array.isArray(contractDrugFamilyGrid) ? contractDrugFamilyGrid : []}
                data-testid="onEditingStopped"
                selectRowIndex={0}
                enterMovesDown
                showResetFilter={false}
                defaultCol={{
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                }}
                hideTotalCount={false}
                exportFile
                fileName="Contract"
                reportName="Contract"
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={changeFullScreenView}
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;

                    if (name && name.length > 20) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
                //   info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
                //   pinnedBottomRowData={pinnedBottomRowData}
              />
            )}

            {selectType === 'Market Basket' && (
              <TableGridWithFeatures
                gridHeight={fullScreenView ? 600 : viewPortHeight_350}
                columnDefs={contractMarketBasketTableColDefs}
                onSelectionChanged={onSelectionChanged}
                rowData={Array.isArray(contractMarketBasketGrid) ? contractMarketBasketGrid : []}
                selectRowIndex={0}
                data-testid="onEditingStopped"
                enterMovesDown
                showResetFilter={false}
                defaultCol={{
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                }}
                hideTotalCount={false}
                exportFile
                fileName="Contract"
                reportName="Contract"
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={changeFullScreenView}
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;

                    if (name && name.length > 20) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
                //   info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
                //   pinnedBottomRowData={pinnedBottomRowData}
              />
            )}

            {selectType === 'Contract' && (
              <TableGridWithFeatures
                gridHeight={fullScreenView ? 600 : viewPortHeight_350}
                columnDefs={contractTableColDefs}
                onSelectionChanged={onSelectionChanged}
                selectRowIndex={0}
                rowData={Array.isArray(contractGrid) ? contractGrid : []}
                data-testid="onEditingStopped"
                enterMovesDown
                showResetFilter={false}
                defaultCol={{
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                }}
                hideTotalCount={false}
                exportFile
                fileName="Contract"
                reportName="Contract"
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={changeFullScreenView}
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;

                    if (name && name.length > 20) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
                //   info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
                //   pinnedBottomRowData={pinnedBottomRowData}
              />
            )}
          </div>
        </div>
        <AdditionalTableDialog
          data-testid="contract-search"
          className="dialog-420"
          open={open}
          viewHeader
          viewAction
          onOk={() => {
            dispatch(setOpenValue(false));
            onSelectContractFromAdditionalTable();
          }}
          okTitle="Ok"
          onClose={() => {
            dispatch(setOpenValue(false));
          }}
          closeTitle="Cancel"
          modalTitle="Select Contract"
          dialogSpace="custom-panel"
          childrenComponent={
            <div className="unallocated" style={{ width: '70vw' }}>
              <TableGridWithFeatures
                gridHeight={200}
                columnDefs={
                  selectType === 'Drug Family'
                    ? drugFamilyContractTableHead
                    : marketBasketContractTableHead
                }
                onSelectionChanged={onContractSelectionChanged}
                rowData={Array.isArray(drugFamilyContractGrid) ? drugFamilyContractGrid : []}
                selectRowIndex={0}
                data-testid="onEditingStopped2"
                enterMovesDown
                showResetFilter={false}
                defaultCol={{
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                }}
              />
            </div>
          }
        />
      </div>
    </div>
  );
};

export default RequestContract;
